import { Button, Card, Flex, Heading, Separator, Text } from "@radix-ui/themes";
import type { KioskBindingV1 } from "../model/kiosk-binding";

export function StaffResumeChoice({
  binding,
  onContinue,
  onReconfigure,
  onCancel,
}: {
  binding: KioskBindingV1;
  onContinue: () => void;
  onReconfigure: () => void;
  onCancel: () => void;
}) {
  return (
    <main className="h-dvh bg-gray-2 flex items-center justify-center p-6">
      <Card className="w-full max-w-[520px] !p-7 shadow-xl">
        <Heading mb="2">Saved kiosk setup</Heading>
        <Text as="p" color="gray" mb="6">
          This device already has a kiosk configuration. Confirm whether to
          continue it or select a new store, zone, and placement.
        </Text>

        <Flex direction="column" gap="3" className="rounded-xl bg-gray-3">
          <SavedValue label="Store" value={binding.storeName} />
          <SavedValue label="Zone" value={binding.zoneName} />
          <SavedValue
            label="Placement"
            value={binding.placement === "enter" ? "Entrance" : "Exit"}
          />
        </Flex>

        <Flex direction="column" gap="3" mt="6">
          <Button size="4" onClick={onContinue}>
            Continue previous setup
          </Button>
          <Button size="4" variant="soft" onClick={onReconfigure}>
            Reconfigure from scratch
          </Button>
          <Separator size="4" />
          <Button size="4" variant="soft" color="gray" onClick={onCancel}>
            Cancel
          </Button>
        </Flex>
      </Card>
    </main>
  );
}

function SavedValue({ label, value }: { label: string; value: string }) {
  return (
    <Flex justify="between" gap="4">
      <Text color="gray">{label}</Text>
      <Text weight="medium" align="right">
        {value}
      </Text>
    </Flex>
  );
}
